__turbopack_context__.v({
  "aiDeleteButton": "OazVPG_aiDeleteButton",
  "aiWrapper": "OazVPG_aiWrapper",
  "baseClass": "OazVPG_baseClass",
  "button": "OazVPG_button",
  "deleteButton": "OazVPG_deleteButton",
  "label": "OazVPG_label",
  "labelContainer": "OazVPG_labelContainer",
  "popoverContent": "OazVPG_popoverContent",
  "tooltipFadeIn": "OazVPG_tooltipFadeIn",
});
